export default "__VITE_ASSET__ClwkKMDo__"